module.exports = __webpack_public_path__ + "pc/img/main_visual.c71fe54f.jpg";